<section class="not-found">
  <div class="img-wrapper">
    <img alt="Page Not Found" src="assets/illustrations/404.svg" />
  </div>
  <h1 class="mt-48" translate>Not Found</h1>
  <button (click)="navigateToPreviousPage()" class="button button-primary-outline button-small button-prefix-icon-start mt-30">
    <app-icon color="var(--orange)" iconName="chevron-left" marginRight="5px"></app-icon>
    Back
  </button>
</section>
